import { jsxs as t, jsx as a, Fragment as p } from "@emotion/react/jsx-runtime";
import { useState as h } from "react";
import { Stack as g, Text as u, Icon as b, FontAwesomeIconsPartooUsed as c, IconPrefix as x, Expandable as _ } from "@partoohub/ui";
import { DropdownContainer as C, Grid as f, StyledSelectableCard as k } from "./SelectableFilterView.styled.js";
import { useDynamicFiltersContext as y } from "../../../DynamicFiltersContext.js";
import { updateSelectableCard as S } from "../../../reducer/dynamicFilters.actions.js";
const P = ({
  filterMeta: r
}) => {
  const [o, l] = h(!0), {
    preFilters: d,
    dispatch: m
  } = y(), s = () => l((e) => !e), i = (e) => {
    e.preventDefault(), m(S({
      property: r.property,
      value: e.target.name,
      checked: e.target.checked,
      exclusiveValues: r.options.filter((n) => n.exclusive).map((n) => n.name)
    }));
  };
  return /* @__PURE__ */ t(g, { gap: "0", children: [
    /* @__PURE__ */ t(C, { onClick: s, children: [
      /* @__PURE__ */ a(u, { variant: "heading6", children: r.sectionName }),
      /* @__PURE__ */ a(b, { icon: [o ? c.faChevronDown : c.faChevronRight, x.SOLID] })
    ] }),
    /* @__PURE__ */ a(_, { opened: o, children: /* @__PURE__ */ a(f, { numberPerLine: r?.numberPerLine ?? 2, style: {
      marginTop: "16px"
    }, children: r?.options.map((e) => /* @__PURE__ */ a(k, { dataTrackId: `selectable_card__${e.name}__option`, disabled: e.disabled, name: e.name, checked: d[r.property].get(e.name) ?? !1, value: e.name, type: "checkbox", onChange: i, label: /* @__PURE__ */ a(p, { children: e.label }) }, `selectable_card__${e.name}__option`)) }) })
  ] });
};
export {
  P as SelectableFilterView
};
